<template>
  <v-container
    fluid
    class="pt-0"
    v-if="totalBilling && totalBilling.id && totalBilling.summarize"
  >
    <v-flex sm12 xs12 md12 lg12>
      <material-stats-card
        color="green"
        icon="attach_money"
        title="Faturados Pagos e Aberto"
        :value="eficiencia | formatCurrency"
        small-value="%"
        :sub-text="
          'R$ ' +
          (
            this.totalBilling.summarize.pagamento_Enercred -
            this.totalBilling.summarize.inadimplencia
          )
            .toFixed(2)
            .replace('.', ',')
        "
      />
    </v-flex>
    <v-flex sm12 xs12 md12 lg12>
      <material-stats-card
        color="orange"
        icon="money_off"
        title="Não faturado"
        :value="ineficiencia | formatCurrency"
        small-value="%"
        sub-icon="mdi-flag-variant"
        :sub-text="
          'R$ ' + Number(this.ineficienciaValor).toFixed(2).replace('.', ',')
        "
      />
    </v-flex>
    <v-flex sm12 xs12 md12 lg12>
      <material-stats-card
        color="red"
        icon="reduce_capacity"
        title="Atrasados"
        :value="inadimplencia | formatCurrency"
        small-value="%"
        sub-icon="mdi-flag-variant"
        :sub-text="
          'R$ ' +
          Number(this.totalBilling.summarize.inadimplencia)
            .toFixed(2)
            .replace('.', ',')
        "
      />
    </v-flex>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("billing", ["totalBilling"]),
    inadimplencia() {
      if (this.totalBilling && this.totalBilling.summarize) {
        // console.log('inadimplencia: ', this.totalBilling.summarize.inadimplencia)
        // console.log('creditosFaturados: ', this.totalBilling.summarize.pagamento_Enercred)
        return (
          (this.totalBilling.summarize.inadimplencia /
            this.totalBilling.summarize.receita_liquida) *
          100
        );
      }
      return 0;
    },
    eficiencia() {
      if (this.totalBilling && this.totalBilling.summarize) {
        return (
          ((this.totalBilling.summarize.pagamento_Enercred -
            this.totalBilling.summarize.inadimplencia -
            this.totalBilling.summarize.abono) /
            this.totalBilling.summarize.receita_liquida) *
          100
        );
      }
      return 0;
    },
    ineficiencia() {
      if (this.totalBilling && this.totalBilling.summarize) {
        // return 100 - ((this.totalBilling.summarize.creditosFaturados / this.totalBilling.summarize.receita_liquida) * 100) -
        // (this.totalBilling.summarize.inadimplencia / this.totalBilling.summarize.pagamento_Enercred) * 100
        return (
          (1 -
            this.totalBilling.summarize.pagamento_Enercred /
              this.totalBilling.summarize.receita_liquida) *
          100
        );
      }
      return 0;
    },
    ineficienciaValor() {
      if (this.totalBilling && this.totalBilling.summarize)
        return (
          this.totalBilling.summarize.receita_liquida -
          this.totalBilling.summarize.pagamento_Enercred
        );
      return 0;
    },
  },
};
</script>
